import React, { useCallback, useMemo, useState } from 'react';
import { Button, Container } from 'react-bootstrap';
import { Eye } from 'lucide-react';
import { getUserFromLocalstrorage, isAdmin } from '../../helpers/global';
import ReconciliationTab from './ReconciliationTab';
import StatementTabSwitcher from './StatementTabSwitcher';
import UnpaidStatementsInvoicesTab from './UnpaidStatementsInvoicesTab';

const StatementPage = () => {
  const [activeTab, setActiveTab] = useState('statement');
  const [unpaidCount, setUnpaidCount] = useState(0);
  const [pendingReconciliationCount, setPendingReconciliationCount] = useState(0);
  // When set, admin is viewing the shared Statement UI as that single client
  const [viewingAsClient, setViewingAsClient] = useState(null);
  const [viewAsClientTarget, setViewAsClientTarget] = useState(null);
  const currentUserInfo = useMemo(() => getUserFromLocalstrorage(), []);
  const isAdminUser = isAdmin(currentUserInfo?.role) && !viewingAsClient;

  const handleViewAsClientTargetChange = useCallback(target => {
    setViewAsClientTarget(target);
  }, []);

  const handleTabCountsChange = useCallback(({ unpaidCount: unpaid, pendingReconciliationCount: pending }) => {
    if (unpaid !== undefined) {
      setUnpaidCount(unpaid);
    }
    if (pending !== undefined) {
      setPendingReconciliationCount(pending);
    }
  }, []);

  return (
    <Container fluid className="d-flex flex-column px-4 px-lg-5 py-3 h-100" style={{ maxWidth: '100%' }}>
      {viewingAsClient && (
        <div
          className="d-flex align-items-center justify-content-between mb-3 px-3 py-2 border bg-muted"
          style={{ borderRadius: 8 }}
        >
          <span className="smallFont text-secondary">
            Viewing as <strong className="text-dark">{viewingAsClient.organizationName}</strong>
          </span>
          <Button size="sm" variant="outline-light" className="bg-white border shadow-none hover-light text-dark" onClick={() => setViewingAsClient(null)}>
            Exit client view
          </Button>
        </div>
      )}

      {isAdminUser && (
        <StatementTabSwitcher
          activeTab={activeTab}
          onTabChange={setActiveTab}
          unpaidCount={unpaidCount}
          pendingReconciliationCount={pendingReconciliationCount}
          rightAction={
            activeTab === 'statement' && viewAsClientTarget ? (
              <Button
                variant="outline-light"
                size="sm"
                type="button"
                className="d-flex align-items-center flex-shrink-0 border shadow-none text-dark hover-light"
                style={{ borderColor: '#cccccc' }}
                onClick={() => setViewingAsClient(viewAsClientTarget)}
              >
                <span className="mr-1 d-inline-flex align-items-center flex-shrink-0">
                  <Eye size={16} color="black" />
                </span>
                <span className="xsmallFont">View as client</span>
              </Button>
            ) : null
          }
        />
      )}

      {(!isAdminUser || activeTab === 'statement') && (
        <UnpaidStatementsInvoicesTab
          onTabCountsChange={handleTabCountsChange}
          viewingAsClient={viewingAsClient}
          onViewAsClientTargetChange={handleViewAsClientTargetChange}
        />
      )}

      {activeTab === 'reconciliation' && isAdminUser && <ReconciliationTab onTabCountsChange={handleTabCountsChange} />}
    </Container>
  );
};

export default StatementPage;
